/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import type { Dispatch, FC, MutableRefObject, SetStateAction } from 'react';

import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';

import FormFieldSelect from '@modules/form/components/FormFieldSelect';

import { makeSelectEdmOperatorConnectionTranslation } from '../../internationalization/intSelectors';
import { EEdmDeliveryInfoFields } from '../constants';
import type { IAddEdmConnectionForm, IEdmOptionItem } from '../types';

interface IProps {
    initialOption: IEdmOptionItem;
    options: IEdmOptionItem[];
    setIsShowContactFields: Dispatch<SetStateAction<boolean>>;
    currentFormData: MutableRefObject<IAddEdmConnectionForm>;
    isChangeMode: boolean;
};

export const EdmOperatorsSelector: FC<IProps> = (
    { options, setIsShowContactFields, initialOption, currentFormData, isChangeMode }) => {
    const { start: tConnectionStart } = useSelector(makeSelectEdmOperatorConnectionTranslation());

    const { resetForm, values } = useFormikContext<IAddEdmConnectionForm>();

    const handleSelect = (option: IEdmOptionItem) => {
        setIsShowContactFields(initialOption.value !== option.value
            && !!option.isRoaming);

        if (isChangeMode) {
            currentFormData.current = {
                operator: option,
                name: values.name,
                email: values.email,
                phone: values.phone,
            };

            if  (!option.isRoaming) {
                setTimeout(() => resetForm({
                    values: currentFormData.current,
                }));
            }
        }

        if (!isChangeMode && !option.isRoaming) {
            setTimeout(() => resetForm({
                values: { operator: option },
            }));
        }
    };

    return <FormFieldSelect
        dataName='edm-select-operators'
        name={EEdmDeliveryInfoFields.operator}
        options={options}
        placeholder={tConnectionStart.selectOperatorTitle}
        onSelect={handleSelect}
    />
};
